import React, { useState, useEffect } from "react";
import { makeStyles, Button, Grid, Snackbar } from "@material-ui/core";
import Typography from "@mui/material/Typography";
import MuiAlert from "@mui/material/Alert";
import PubSub from "pubsub-js";

import settingSvg from "../../assets/svg/setting.svg";
import eyeSvg from "../../assets/svg/eye.svg";
import translatorSvg from "../../assets/svg/translator.svg";
import collectSvg from "../../assets/svg/collect.svg";
import cancelCollectSvg from "../../assets/svg/cancelCollect.svg";
import shareSvg from "../../assets/svg/share.svg";
import downSvg from "../../assets/svg/arrow-down.svg";
import downloadSvg from "../../assets/svg/download.svg";
import upSvg from "../../assets/svg/arrow-up.svg";
import flowSvg from "../../assets/images/icon-flow.svg";
import axios from "axios";

const useStyles = makeStyles({
  card: {
    minHeight: "213px",
    marginBottom: "23px",
    padding: "14px 16px 0",
    background: "#FFFFFF",
    boxShadow: "0px 1px 5px 1px rgba(0, 0, 0, 0.1)",
    borderRadius: "10px",
  },
  timeLineBox: {
    position: "relative",
    paddingLeft: "30px",
  },
  timeLine: {
    position: "absolute",
    left: "14px",
    top: "0",
    width: "1px",
    height: "100%",
    background: "rgba(9, 10, 11, 0.23)",
    "&.clear": {
      top: "6px",
      height: "calc(100% - 6px)",
    },
  },
  timeLineCircle: {
    position: "absolute",
    left: "7px",
    top: "6px",
    width: "16px",
    height: "16px",
    background: "#fff",
    border: "2px solid #2BBFB6",
    borderRadius: "50%",
    boxSizing: "border-box",
    zIndex: "10",
  },
  timeLabel: {
    display: "inline-block",
    width: "105px",
    height: "28px",
    marginBottom: "12px !important",
    fontSize: "18px",
    color: "#fff",
    lineHeight: "28px",
    borderRadius: "14px",
    textAlign: "center",
    background: "#2BBFB6",
  },
  titleLine: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  flexCenter: {
    width: "1px",
    display: "flex",
    alignItems: "center",
    flex: 1,
  },
  status: {
    minWidth: "70px",
    height: "32px",
    padding: "0 8px",
    marginLeft: "40px",
    background: (medical_file) => {
      if (medical_file.medical_file_law_status == "征求意见稿") {
        return "#FCD600";
      } else if (medical_file.medical_file_law_status == "暂行") {
        return "#FF6100";
      } else if (medical_file.medical_file_law_status == "即将实施") {
        return "#64AAD6";
      } else if (medical_file.medical_file_law_status == "废止") {
        return "#666666";
      } else if (medical_file.medical_file_law_status == "试行") {
        return "#39C07A";
      } else {
        return "#A4D322";
      }
    },
    borderRadius: "16px",
    fontSize: "14px",
    textAlign: "center",
    color: "#fff",
    lineHeight: "32px",
  },
  tag: {
    width: "38px",
    height: "38px",
    marginRight: "12px !important",
    background: (medical_file) => {
      if (medical_file.base_file.file_category == "指导原则") {
        return "#FF9E00";
      }
      if (medical_file.base_file.file_category == "法规") {
        return "#42BD57";
      }
      if (medical_file.base_file.file_category == "指导原则FDA") {
        return "#39C07A";
      }
      if (medical_file.base_file.file_category == "标准") {
        return "#64AAD6";
      }
      if (medical_file.base_file.file_category == "参考件") {
        return "#666666";
      }
      return "#5F6876";
    },
    borderRadius: "50%",
    color: "#fff",
    fontSize: "18px",
    fontWeight: "bold",
    textAlign: "center",
    lineHeight: "38px",
  },
  title: {
    flex: 1,
    fontSize: "18px  !important",
    color: "#4a4a4a",
    fontWeight: "bold !important",
    // overflow: "hidden",
    // whiteSpace: "nowrap",
    // textOverflow: "ellipsis",
    cursor: "pointer",
  },
  fileName: {
    fontSize: "15px  !important",
    color: "#4a4a4a",
    fontWeight: "bold !important",
    cursor: "pointer",
    "&:hover": {
      color: "3276C3",
    },
  },
  fileType: {
    fontSize: "18px  !important",
    color: "#3276C3",
    fontWeight: "bold !important",
  },
  detailBox: {
    marginTop: "8px",
    color: "#4a4a4a",
    fontSize: "14px",
    lineHeight: "20px",
    overflow: "hidden",
  },
  detailLine: {
    marginBottom: "7px !important",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  detail: {
    marginRight: "20px !important",
    "& a": {
      color: "#0F55A4",
      cursor: "pointer",
      fontWeight: "bold",
    },
    "&.bold": {
      fontWeight: "bold",
      color: "#000",
    },
  },
  moreDetail: {
    minWidth: "160px",
    marginRight: "40px !important",
    display: "inline-block",
  },
  btnLine: {
    paddingTop: "12px",
    marginBottom: "14px",
  },
  btnBox: {
    display: "flex",
    justifyContent: "flex-end",
    flexWrap: "wrap",
    borderTop: "1px dashed #D8D8D8",
    "& button": {
      minWidth: "82px",
      height: "32px",
      marginTop: "14px",
      marginLeft: "12px",
      color: "#000",
      "& img": {
        marginRight: "4px",
      },
      "&:hover": {
        border: "1px solid #0F25D1",
        background: "#fff !important",
      },
    },
  },
  moreInfo: {
    overflow: "hidden",
    transition: "height .3s ease-in-out",
    boxSizing: "border-box",
    "&.show": {
      height: "100px",
    },
    "&.hide": {
      height: 0,
    },
  },
  highText: {
    color: "#f00",
  },
});

export default function FileCard(props) {
  const {
    showSetting,
    showFlow,
    showClassify,
    medical_file,
    collect,
    handlePreview,
    handCollect,
    handCancelCollect,
    handSetting,
    handFlow,
    handleDiagram,
    showTimeLine,
    highText,
    keyword,
    clearTop,
  } = props;
  const classes = useStyles(medical_file);

  const [expanded, setExpanded] = useState(false);
  const [openMessage, setOpenMessage] = useState(false);
  const [lables, setLables] = useState("");
  const [titleArr, setTitleArr] = useState([]);
  const [showDownload, setShowDownload] = useState(false);

  useEffect(() => {
    PubSub.subscribe("lables", (_, data) => {
      if (medical_file.base_file.file_id == data[1]) {
        var newLables = medical_file.file_lables
          .filter((v) => {
            return v.lable_created_user == "admin";
          })
          .map((v1) => {
            return v1.lable_content;
          });
        var newData = data[0].map((v) => {
          if (newLables.includes(v.lable_content)) {
          } else {
            return v.lable_content;
          }
        });
        setLables(newLables.concat(newData).join(","));
      }
    });
    if (["法规","指导原则"].includes(medical_file.base_file.file_category)){
      setShowDownload(true)
    }
  }, []);

  useEffect(() => {
    setLables("");
    if (highText) {
      initTitle();
    }
  }, [medical_file]);

  const changeShow = () => {
    setExpanded(!expanded);
  };

  const initTitle = () => {
    let result = [];
    let title = medical_file.base_file.file_name;
    let titleStr = title.substring(0, title.length - 4);
    // 截取搜索词
    if (titleStr.indexOf(keyword) > -1) {
      let chatArr = [keyword];
      result = getShortTitle(chatArr, titleStr);
    } else {
      let shortChatArr = getKeywordChat();

      result = getShortTitle(shortChatArr, titleStr);
    }
    setTitleArr(result);
  };

  const getShortTitle = (chatArr, titleStr) => {
    let indexArr = [];
    let result = [];
    chatArr.forEach((v) => {
      let index = titleStr.indexOf(v);
      while (index > -1) {
        indexArr.push({
          index: index,
          size: v.length,
        });
        index = titleStr.indexOf(v, index + v.length);
      }
    });
    indexArr = indexArr.sort((a, b) => {
      return a.index - b.index;
    });
    if (indexArr.length == 0) {
      return [
        {
          text: titleStr,
        },
      ];
    }
    for (let i = 0; i < indexArr.length; i++) {
      let index = indexArr[i].index;
      let size = indexArr[i].size;
      let preIndex = 0;
      if (i > 0) {
        preIndex = indexArr[i - 1].index + indexArr[i - 1].size;
      }
      let text = titleStr.substring(preIndex, index);
      result.push({
        text: text,
      });

      let highText = titleStr.substring(index, index + size);
      result.push({
        text: highText,
        high: true,
      });

      if (i == indexArr.length - 1) {
        let text = titleStr.substring(index + size);
        result.push({
          text: text,
        });
      }
    }
    return result;
  };

  const getKeywordChat = () => {
    let chatArr = [];
    // 截取单字
    for (let i = 0; i < keyword.length; i++) {
      let str = keyword.substring(i, i + 1);
      if (/[0-9]/g.test(str)) {
        // 数字不拆分
        let nextStr = keyword.substring(i + 1, i + 2);
        while (/[0-9]/g.test(nextStr) && i < keyword.length - 1) {
          i++;
          str += nextStr;
          nextStr = keyword.substring(i + 1, i + 2);
        }
        chatArr.push(str);
      } else {
        chatArr.push(str);
      }
    }
    //去重
    chatArr = Array.from(new Set(chatArr));
    return chatArr;
  };

  const changeCollect = () => {
    if (collect) {
      handCancelCollect(medical_file.base_file.file_id);
      setLables(
        medical_file.file_lables
          .map((v) => {
            return v.lable_content;
          })
          .join(",")
      );
    } else {
      handCollect(medical_file.base_file.file_id);
    }
  };

  const getPreviewBtn = (data) => {
    if (
      medical_file.base_file.file_category == "参考件" &&
      medical_file.base_file.original_file_url
    ) {
      return (
        <Button
          variant="outlined"
          color="default"
          onClick={() =>
            handlePreview(medical_file.base_file.original_file_url)
          }
        >
          <img src={eyeSvg} />
          查看原件
        </Button>
      );
    }
    // if (
    //   medical_file.base_file.reference_file_url &&
    //   medical_file.base_file.reference_file_url != 0
    // ) {
    //   return (
    //     <Button
    //       variant="outlined"
    //       color="default"
    //       onClick={() =>
    //         handlePreview(medical_file.base_file.reference_file_url)
    //       }
    //     >
    //       <img src={eyeSvg} />
    //       查看参考件
    //     </Button>
    //   );
    // }
  };

  const copyData = () => {
    let data =
      medical_file.base_file.file_name +
      "&#13;" +
      "https://base.anwin.co/share_viewer/" +
      medical_file.base_file.file_id;
    const textarea = document.createElement("textarea");
    document.body.appendChild(textarea);
    textarea.innerHTML = data;
    textarea.select();
    if (document.execCommand("copy")) {
      document.execCommand("copy");
      setOpenMessage(true);
      setTimeout(() => {
        setOpenMessage(false);
      }, 3000);
    }
    document.body.removeChild(textarea);
  };

  const closeMessage = () => {
    setOpenMessage(false);
  };

  const downloadFile = (url, fileName) => {
    axios({
      method: "get",
      url: url,
      responseType: "blob",
    }).then((resp) => {
      if (resp.status === 200) {
        if (window.navigator.msSaveOrOpenBlob) {
          let blob = resp.data;
          navigator.msSaveBlob(blob, fileName);
        } else {
          let blob = new Blob([resp.data], { type: "text" });
          let a = document.createElement("a");
          a.download = fileName;
          let URL = window.URL || window.webkitURL;
          a.href = URL.createObjectURL(blob);
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      }
    });
  };
  

  return (
    <Grid container className={showTimeLine ? classes.timeLineBox : ""}>
      {showTimeLine && medical_file.showTime ? (
        <Grid item xs={12}>
          <Typography variant="span" className={classes.timeLabel}>
            {medical_file.medical_file_publish_date
              .substring(0, 7)
              .replace("-", ".")}
          </Typography>
          <div className={classes.timeLineCircle}></div>
        </Grid>
      ) : null}
      {showTimeLine ? (
        <div
          className={[classes.timeLine, clearTop ? "clear" : ""].join(" ")}
        ></div>
      ) : null}
      <Grid item xs={12} className={classes.card}>
        <div className={classes.titleLine}>
          <div className={classes.flexCenter}>
            <Typography variant="span" className={classes.tag}>
              {medical_file.base_file.file_category.substring(0, 1)}
            </Typography>
            <Typography
              className={classes.title}
              onClick={() => handlePreview(medical_file.base_file.dfs_url)}
            >
              {" "}
              <span
                className={classes.fileName}
                title={medical_file.base_file.file_name}
              >
                {highText ? (
                  titleArr.map((v, i) =>
                    v.high ? (
                      <span className={classes.highText} key={i}>
                        {v.text}
                      </span>
                    ) : (
                      <span key={i}>{v.text}</span>
                    )
                  )
                ) : (
                  <span>
                    {medical_file.base_file.file_name.substring(
                      0,
                      medical_file.base_file.file_name.length - 4
                    )}
                  </span>
                )}

                <span className={classes.fileType}>
                  {medical_file.base_file.file_name
                    .substring(medical_file.base_file.file_name.length - 4)
                    .toUpperCase()}
                </span>
              </span>
            </Typography>

            {/* <Typography
              className={classes.title}
              onClick={() => handlePreview(medical_file.base_file.dfs_url)}
            ></Typography> */}
          </div>
          <div className={classes.status}>
            {medical_file.medical_file_law_status}
          </div>
        </div>

        <div className={classes.detailBox}>
          <Typography className={classes.detailLine}>
            <Typography
              variant="span"
              className={[classes.detail, highText ? "bold" : ""].join(" ")}
            >
              发布时间：
              {medical_file.medical_file_publish_date.substring(0, 10)}
            </Typography>
            {medical_file.medical_file_law_status == "征求意见稿" ? (
              <Typography variant="span" className={classes.detail}>
                截止时间：
                {medical_file.medical_file_expired_date.substring(0, 10)}
              </Typography>
            ) : (
              medical_file.medical_file_force_date.substring(0, 10) !=
                "1970-01-01" && (
                <Typography variant="span" className={classes.detail}>
                  生效时间：
                  {medical_file.medical_file_force_date.substring(0, 10)}
                </Typography>
              )
            )}
            <Typography variant="span" className={classes.detail}>
              发布机构：
              {medical_file.medical_file_publish_orgnization}
            </Typography>
          </Typography>
          {!showClassify && (
            <Typography className={classes.detailLine}>
              标签：
              {/* {medical_file.file_lables ? medical_file.file_lables.join() : ""} */}
              {lables
                ? lables
                : medical_file.file_lables
                ? medical_file.file_lables
                    .map((v) => {
                      return v.lable_content;
                    })
                    .join(",")
                : ""}
            </Typography>
          )}

          {showClassify && (
            <Typography className={classes.detailLine}>
              分类标签：
              {medical_file.file_lables_zgfx
                ? medical_file.file_lables_zgfx
                    .map((v) => {
                      return v.lable_content;
                    })
                    .join(",")
                : ""}
            </Typography>
          )}

          <Typography className={classes.detailLine}>
            适用产品：{medical_file.medical_file_products_name}
          </Typography>
        </div>

        <div className={classes.btnLine}>
          <div className={classes.btnBox}>
            {showFlow && (
              <Button
                variant="outlined"
                color="default"
                onClick={() => handFlow(medical_file)}
              >
                <img src={flowSvg} />
                发起分类流程
              </Button>
            )}
            {showSetting && (
              <Button
                variant="outlined"
                color="default"
                onClick={() => handSetting(medical_file.base_file.file_id)}
              >
                <img src={settingSvg} />
                管理标签
              </Button>
            )}
            {getPreviewBtn(medical_file)}
            {medical_file.base_file.is_referenced && (
              <Button
                variant="outlined"
                color="default"
                onClick={() => handleDiagram(medical_file.base_file.file_id)}
              >
                <img src={eyeSvg} />
                查看参考件
              </Button>
            )}

            {/* <Button variant="outlined" color="default">
              <img src={translatorSvg} />
              翻译
            </Button> */}
            <Button variant="outlined" color="default" onClick={changeCollect}>
              <img src={collect ? collectSvg : cancelCollectSvg} />
              {collect ? "取消收藏" : "收藏"}
            </Button>
            <Button variant="outlined" color="default" onClick={copyData}>
              <img src={shareSvg} />
              分享
            </Button>
            {
              showDownload && 
              <Button variant="outlined" color="default" onClick={() => downloadFile(medical_file.base_file.dfs_url, medical_file.base_file.file_name)}>
                <img src={downloadSvg} />
                下载
              </Button>
            }
            
            <Button variant="outlined" onClick={changeShow} color="default">
              <img src={expanded ? upSvg : downSvg} />
              {expanded ? "收起" : "展开"}
            </Button>
          </div>
        </div>

        <div
          className={[classes.moreInfo, expanded ? "show" : "hide"].join(" ")}
        >
          <Typography className={classes.detailLine}>
            <Typography variant="span" className={classes.detail}>
              来源网站目录： {medical_file.medical_file_origin_website_catalog}
            </Typography>

            {medical_file.medical_file_website_link &&
              medical_file.medical_file_website_link !== "-" &&
              medical_file.medical_file_website_link !== "N/A" && (
                <Typography variant="span" className={classes.detail}>
                  <a
                    target="_blank"
                    href={medical_file.medical_file_website_link}
                  >
                    原文链接
                  </a>
                </Typography>
              )}
          </Typography>

          <Typography className={classes.detailLine}>
            <Typography variant="span" className={classes.moreDetail}>
              文件类型： {medical_file.base_file.file_category}
            </Typography>
            <Typography variant="span" className={classes.moreDetail}>
              管辖区域： {medical_file.medical_file_admin_location}
            </Typography>
          </Typography>

          <Typography className={classes.detailLine}>
            <Typography variant="span" className={classes.moreDetail}>
              器械类别： {medical_file.medical_file_instrument_category}
            </Typography>
            <Typography variant="span" className={classes.moreDetail}>
              器械等级： {medical_file.medical_file_instrument_level}
            </Typography>
          </Typography>
        </div>
      </Grid>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={openMessage}
        onClose={closeMessage}
      >
        <MuiAlert elevation={6} variant="filled" severity="success">
          内容复制成功，可以直接在别处粘贴。
        </MuiAlert>
      </Snackbar>
    </Grid>
  );
}
